var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5768 3.70699C18.606 2.97786 18.007 2.37887 17.2779 2.40803L11.3853 2.64373C11.0713 2.65629 10.7736 2.78665 10.5514 3.00885L2.61905 10.9412C2.13089 11.4294 2.13089 12.2208 2.61905 12.709L8.2759 18.3658C8.76405 18.854 9.55551 18.854 10.0437 18.3658L17.976 10.4335C18.1982 10.2113 18.3286 9.91354 18.3411 9.59955L18.5768 3.70699ZM17.2179 0.909231C18.822 0.845067 20.1398 2.16285 20.0756 3.76695L19.8399 9.6595C19.8123 10.3503 19.5255 11.0053 19.0367 11.4941L11.1043 19.4265C10.0304 20.5004 8.28918 20.5004 7.21524 19.4265L1.55839 13.7696C0.484444 12.6957 0.484444 10.9545 1.55839 9.88054L9.49073 1.94819C9.97957 1.45935 10.6346 1.17256 11.3254 1.14493L17.2179 0.909231Z",
    fill: "current"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 5.5,
    r: 1.5,
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/Tag.acc2cbd8b1c48415c5d402bc4c780936.svg";
export { ForwardRef as ReactComponent };